import { Categories, MobileMenuItems, SelectedMenuItem } from '../types'

export type MenuTab = 'categories' | 'brands'

export const MOBILE_MENU_TABS: { id: MenuTab; label: string }[] = [
    { id: 'categories', label: 'دسته‌بندی‌ها' },
    { id: 'brands', label: 'برندها' },
]

export const SPECIAL_OFFER_CHILDREN: Categories[] = [
    {
        categories: [
            { title: 'پیشنهاد ویژه', href: '/tags/takhfif50', useHrefWithoutParent: true },
            { title: 'جعبه صورتی', href: '/tags/festival-js', useHrefWithoutParent: true },
            { title: 'جعبه جادویی', href: '/videos', useHrefWithoutParent: true },
            { title: 'مجله خانومی', href: '/blog', useHrefWithoutParent: true },
            { title: 'کارت هدیه سازمانی', href: '/landing/giftcard-org', useHrefWithoutParent: true },
        ],
    },
]

export const DEFAULT_SELECTED_MENU_ITEM: SelectedMenuItem = {
    id: MobileMenuItems.SpecialOffer,
    title: 'ویژه',
    href: '',
    subMenuChildren: SPECIAL_OFFER_CHILDREN,
}
